// 来源于 redux-saga - 对于task执行顺序的控制，保证在同一时间只有一个task会被执行
// 使用计数加减来进行执行过程的锁定
const queue = [];
let lockCount = 0;

const suspend = () => {
	lockCount++;
};
const release = () => {
	lockCount--;
};
// 执行任务 - 任务执行前必定进行锁定操作
const exec = (task) => {
	try {
		suspend();
		task();
	} finally {
		release();
	}
};
// 执行当前的所有任务，在执行之前一定要保证进入了锁状态
const flush = () => {
	release();
	let task;
	while (!lockCount && (task = queue.shift()) !== undefined) {
		exec(task);
	}
};

// 增加执行队列，如果队列处于没有启动的状态，启动执行队列
export const asap = (task) => {
	queue.push(task);
	if (!lockCount) {
		suspend();
		flush();
	}
};
// 立刻执行任务，在执行结束后进行队列清扫
export const immediately = (task) => {
	try {
		suspend();
		return task();
	} finally {
		flush();
	}
};
